import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import ReactSlider from 'react-slick';

const Slider = ({ children, className, dotsClass, ...props }) => (
  <div className={classNames('slider', className)}>
    <ReactSlider {...props} dotsClass={dotsClass}>
      {children}
    </ReactSlider>
  </div>
);

Slider.defaultProps = {
  dotsClass: 'slider__dots'
};

Slider.propTypes = {
  children: PropTypes.any,
  dotsClass: PropTypes.string,
  className: PropTypes.string
};

export default Slider;
